import { CurriculumPreviewPageController } from './curriculum-preview-page.controller';
import { CurriculumPreviewPageProps } from './curriculum-preview-page.model';

export const CurriculumPreviewPage = (props: CurriculumPreviewPageProps) => {
  return <CurriculumPreviewPageController {...props} />;
};
